module.exports = __webpack_public_path__ + "static/chrislowell-b-154x300-b3aec38bae2d108c201a97578bc8a891.jpg";